import { analyticsConstants } from "../constants/ActionTypes";
import { baseUrl } from "../constants/baseUrl";

export const getTableDRDataAction = (paramObj, onSuccess, onFailure) => ({
    type: analyticsConstants.GET_TABLE_DATE_RANGE_REPORT,
    payload: paramObj,
    meta: {
        type: 'apijson',
        url: baseUrl + '/table_date_range_report',
        onSuccess: onSuccess,
        onFailure: onFailure,
        params: {
            shop_id: paramObj.shopId,
            date_first: paramObj.dateFirst,
            date_second: paramObj.dateSecond
        },
        options: {
            method: 'GET'
        }
    }
})